export var STREAM_CHAT_USE_CASE = 'STREAM_CHAT_USE_CASE';
export var GET_AI_CHAT_USAGE_WALLET_USE_CASE = 'GET_AI_CHAT_USAGE_WALLET_USE_CASE';
export var GET_AI_CHAT_ACCOUNTING_SUBSCRIPTION_USE_CASE = 'GET_AI_CHAT_ACCOUNTING_SUBSCRIPTION_USE_CASE';
export var APPEND_AI_MESSAGE_ON_STREAM_DONE = 'APPEND_AI_MESSAGE_ON_STREAM_DONE';
export var ADD_STOPPED_MESSAGE = 'ADD_STOPPED_MESSAGE';
export var ADD_ATTACHMENTS = 'ADD_ATTACHMENTS';
export var REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT';
export var CLEAR_ATTACHMENTS = 'CLEAR_ATTACHMENTS';